// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component } from '@angular/core';

//Token
import { authToken } from '../../shared/authToken';

// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CappComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    styles : ['.capp-main-content-div{position:absolute;top:0;right:0;bottom:0;left:0px;display:flex;flex-direction:column;min-width:450px}.capp-main-control-div{flex-grow:0;display:flex;flex-wrap:wrap;align-items:center;margin:0 8px 10px 8px;padding:0 8px;background-color:#eee;border:solid 1px #ddd;border-radius:4px}.capp-filter-control-div{flex-grow:0;display:flex;align-items:center;margin:0 8px 10px 8px;padding:0 8px;border-radius:4px}.capp-legend-item-div{margin:0 16px 0 2px}.capp-main-grid-div{flex-grow:1;position:relative;margin-top:15px;border-top:solid 1px #ccc}.capp-control-lbl{margin-right:4px}.capp-filter-radio{padding-left:10px;display:flex;align-items:center}.capp-main-control-break{flex-basis:100%;height:0}.capp-cssClasses_Grid{border-top:solid 1px #bbb}.capp-cssClasses_Cell{border-right:solid 1px #ccc;padding:2px 4px !important;margin:0}.capp-cssClasses_EditableCell_incomplete{border:solid 1px orange !important}.capp-cssClasses_EditableCell_complete{border:solid 1px green !important}'],
    template : '<router-outlet></router-outlet>',
    providers:[]
})
export class CappComponent implements OnInit{};